import axiosAuth from '../../axiosMain';
import vueStore from '@/store';
import Vue from 'vue';

async function index() {
  try {
    let response = await axiosAuth.get('/dashboard_elements');
    return response.data.data;
  } catch (e) {}
}

async function store(data) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }
  let response = await axiosAuth.post('/dashboard_elements', form);
  if (data['display'] === true) vueStore.dispatch('refreshCategories');
  return response.data.data;
}

async function update(data, id) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }
  let response = await axiosAuth.post('/dashboard_elements/' + id, form);
  if (data['display'] === true) vueStore.dispatch('refreshCategories');
  return response.data.data;
}

export default {
  index,
  store,
  update,
};
